<template>
  <div>
    <HeaderBanner
      :visible="visible"
      :promotion-url="redirectLink"
      :info="info"
      :discount-code="discountCode"
      :background-color="backgroundHexColor"
      :text-color="textHexColor"
      :background-color-button="backgroundHexColorButton"
      :text-color-button="textHexColorButton"
      :border-color-button="borderHexColorButton"
      :data-ab-id="dataABId"
      :legal-text="legalText"
      :legal-title="legalTitle"
      :enable-legal-disclaimer="enableLegalDisclaimer"
      :show-in-p-l-p="showInPLP"
      :show-in-p-d-p="showInPDP"
      :show-in-cart="showInCart"
      :show-in-wishlist="showInWishlist"
      :show-in-account-area="showInAccountArea"
      :show-in-all-content-pages="showInAllContentPages"
      :show-on-all-pages="showOnAllPages"
      :show-on-home-page="showOnHome"
      :include-pages="includePages ?? []"
      :exclude-pages="excludePages ?? []"
    />
  </div>
</template>

<script lang="ts" setup>
import { WrapperProps, BannerBuilder } from './Banner.model';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps(WrapperProps);
const mgnlProps = BannerBuilder.build(props);
const {
  isHidden,
  backgroundColor,
  textColor,
  backgroundColorButton,
  textColorButton,
  borderColorButton,
  dataABId,
  discountCode,
  info,
  legalText,
  legalTitle,
  enableLegalDisclaimer,
  showInPLP,
  showInPDP,
  showInCart,
  showInWishlist,
  showInAccountArea,
  showInAllContentPages,
  showOnHome,
  showOnAllPages,
  includePages,
  excludePages,
} = mgnlProps;

const visible = !isHidden;
const backgroundHexColor = magnoliaGetters.getHexColor(backgroundColor);
const textHexColor = magnoliaGetters.getHexColor(textColor);
const backgroundHexColorButton = magnoliaGetters.getHexColor(backgroundColorButton);
const textHexColorButton = magnoliaGetters.getHexColor(textColorButton);
const borderHexColorButton = magnoliaGetters.getHexColor(borderColorButton);
const redirectLink = magnoliaGetters.getLinkAndName(mgnlProps).url;
</script>
